module.exports = __webpack_public_path__ + "images/demand.6c7a250e.svg";